import { render } from "./OpSlots.vue?vue&type=template&id=e8851f0a&scoped=true"
import script from "./OpSlots.vue?vue&type=script&lang=js"
export * from "./OpSlots.vue?vue&type=script&lang=js"

import "./OpSlots.vue?vue&type=style&index=0&id=e8851f0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8851f0a"]])

export default __exports__